export default __webpack_public_path__ + "static/media/ic-csv.d4a230d4.svg";